// Isolated candidate study. No accepted registry entry or production anatomy claim.
const freeze=x=>{if(x&&typeof x==='object'){Object.freeze(x);Object.values(x).forEach(freeze);}return x;};
export const MALLARD_PILOT_PROFILE=freeze({
  "id": "mallard-pilot-15a",
  "candidateOnly": true,
  "units": "metres",
  "up": "+Y",
  "forward": "-Z",
  "scale": 0.1755,
  "waterlineMetres": 0.13,
  "pitchRadians": 0,
  "rollRadians": 0,
  "durationSeconds": 2.8,
  "sequenceId": "floating-paddle-idle",
  "motionScope": "finite-authored-study-hold-after-end",
  "floatScope": "kinematic-draft-reference-no-hydrodynamic-equilibrium",
  "sweptBounds": {
    "min": [
      -0.09521560370922089,
      -0.06158331781625748,
      -0.41479045152664185
    ],
    "max": [
      0.09522151947021484,
      0.3298454284667969,
      0.2750000059604645
    ]
  },
  "assets": {
    "full": {
      "model": {
        "file": "full.glb",
        "bytes": 2364060,
        "sha256": "ce5988b4338b821e2b913b2ddad5a84c2f0cd4d7499c3c01af4be5cc636078ff"
      },
      "motion": {
        "file": "full-motion.json",
        "bytes": 619376,
        "sha256": "f3055cc9bacc3c430609e31321ffbbb1726b44f2a2c433fe53816427a4189e2d"
      },
      "triangles": 48892,
      "primitives": 27,
      "joints": 22
    },
    "proxy": {
      "model": {
        "file": "proxy.glb",
        "bytes": 446196,
        "sha256": "146b088f1b126694ea1f6a2c8d9f78fe7c83a9d78493941386431a6757f572be"
      },
      "motion": {
        "file": "proxy-motion.json",
        "bytes": 619737,
        "sha256": "0d6af47a6cdbb50f78f55250861afd97c16d5414e83b44855f27a78a3af3686f"
      },
      "triangles": 5586,
      "primitives": 27,
      "joints": 22
    }
  }
});
